import { TicketDetail } from '../models/ticket.model';

export class AIContextUtil {
  static buildTicketContext(ticket: TicketDetail, getSituationDescription: (situation: string) => string): string {
    const customer = ticket.customer as any;
    const ticketNumber = ticket.ticket_number_teorema || '';
    const summary = ticket.summary || '';
    const problem = ticket.problem || '';
    const customerName = customer?.name || '';
    const status = ticket.status?.description || '';
    const situation = getSituationDescription(ticket.situation);
    const system = ticket.system?.description || '';
    const responsible = ticket.responsible?.name || '';
    const developer = ticket.developer?.name || '';
    const solution = ticket.solution || '';

    const contextLines: string[] = [`# Chamado #${ticketNumber}`];

    if (customerName) contextLines.push(`**Cliente:** ${customerName}`);
    if (system) contextLines.push(`**Sistema:** ${system}`);
    if (status) contextLines.push(`**Status:** ${status}`);
    if (situation) contextLines.push(`**Situação:** ${situation}`);
    if (responsible) contextLines.push(`**Responsável:** ${responsible}`);
    if (developer) contextLines.push(`**Desenvolvedor:** ${developer}`);
    if (summary) contextLines.push(`**Resumo:** ${summary}`);
    if (problem) contextLines.push(`**Problema:** ${problem}`);
    if (solution) contextLines.push(`**Solução:** ${solution}`);

    // Adicionar comentários públicos
    if (ticket.details && ticket.details.length > 0) {
      // Movimentações do HelpDesk não têm observation — entrariam como "undefined" no markdown.
      const publicComments = ticket.details.filter(d => d.pub && d.observation?.trim());
      if (publicComments.length > 0) {
        contextLines.push('\n## Comentários');
        publicComments.forEach(comment => {
          const userName = typeof comment.user === 'string' ? comment.user : (comment.user as any)?.name || 'Usuário';
          contextLines.push(`- **${userName}:** ${comment.observation}`);
        });
      }
    }

    // Adicionar tarefas
    if (ticket.tasks && ticket.tasks.length > 0) {
      contextLines.push('\n## Tarefas');
      ticket.tasks.forEach(task => {
        const taskStatus = task.finished ? '✓' : '○';
        contextLines.push(`${taskStatus} ${task.description || task.summary}`);
      });
    }

    // Adicionar usuários do chamado
    if (ticket.ticketUsers && ticket.ticketUsers.length > 0) {
      contextLines.push('\n## Participantes');
      ticket.ticketUsers.forEach(tu => {
        contextLines.push(`- ${tu.user.name} (${tu.user_type})`);
      });
    }

    return contextLines.join('\n');
  }
}
